// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ccel-search-container {
  background-color: #1e1e1e;
  border-radius: 8px;
  padding: 20px;
  margin: 20px auto;
  color: #f1f1f1;
  max-width: 1200px;
  width: 95%;
}

.ccel-search-container h2 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #f1f1f1;
}

.api-status {
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 14px;
}

.status-ok {
  background-color: rgba(0, 128, 0, 0.2);
  color: #4ade80;
  border: 1px solid #4ade80;
}

.status-partial {
  background-color: rgba(255, 166, 0, 0.2);
  color: #ffa500;
  border: 1px solid #ffa500;
}

.status-error {
  background-color: rgba(255, 0, 0, 0.1);
  color: #ff6b6b;
  border: 1px solid #ff6b6b;
}

.search-form {
  display: flex;
  margin-bottom: 20px;
}

.search-input {
  flex: 1 1;
  padding: 10px 15px;
  border: 1px solid #444;
  border-radius: 5px 0 0 5px;
  background-color: #2d2d2d;
  color: #f1f1f1;
  font-size: 16px;
}

.search-button {
  padding: 10px 20px;
  background-color: #4a7bff;
  color: white;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.search-button:hover:not(:disabled) {
  background-color: #3a67e8;
}

.search-button:disabled {
  background-color: #6c7a9c;
  cursor: not-allowed;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #f1f1f1;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.search-error {
  background-color: rgba(255, 0, 0, 0.1);
  color: #ff6b6b;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0;
}

.search-results {
  min-height: 500px;
  max-height: 800px;
  overflow-y: auto;
  padding: 10px;
  margin-top: 20px;
}

.search-results h3 {
  margin-top: 0;
  margin-bottom: 15px;
  border-bottom: 1px solid #444;
  padding-bottom: 10px;
  position: sticky;
  top: 0;
  background-color: #1e1e1e;
  z-index: 10;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 25px;
}

.result-card {
  background-color: #2d2d2d;
  border-radius: 5px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 200px;
}

.result-card:hover {
  transform: translateY(-5px);
}

.result-card h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #f1f1f1;
  font-size: 18px;
}

.book-summary {
  margin-top: 10px;
  font-size: 14px;
  color: #ccc;
  flex-grow: 1;
  max-height: 100px;
  overflow-y: auto;
}

.result-actions {
  display: flex;
  margin-top: 15px;
  gap: 10px;
}

.read-button, .add-button, .disabled-button {
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  flex: 1 1;
  transition: background-color 0.3s;
}

.read-button {
  background-color: #4a7bff;
  color: white;
  border: none;
  cursor: pointer;
}

.read-button:hover {
  background-color: #3a67e8;
}

.add-button {
  background-color: transparent;
  color: #f1f1f1;
  border: 1px solid #f1f1f1;
  cursor: pointer;
}

.add-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.disabled-button {
  background-color: #555;
  color: #aaa;
  border: none;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/CCELSearch.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,SAAO;EACP,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".ccel-search-container {\n  background-color: #1e1e1e;\n  border-radius: 8px;\n  padding: 20px;\n  margin: 20px auto;\n  color: #f1f1f1;\n  max-width: 1200px;\n  width: 95%;\n}\n\n.ccel-search-container h2 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #f1f1f1;\n}\n\n.api-status {\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  font-size: 14px;\n}\n\n.status-ok {\n  background-color: rgba(0, 128, 0, 0.2);\n  color: #4ade80;\n  border: 1px solid #4ade80;\n}\n\n.status-partial {\n  background-color: rgba(255, 166, 0, 0.2);\n  color: #ffa500;\n  border: 1px solid #ffa500;\n}\n\n.status-error {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: #ff6b6b;\n  border: 1px solid #ff6b6b;\n}\n\n.search-form {\n  display: flex;\n  margin-bottom: 20px;\n}\n\n.search-input {\n  flex: 1;\n  padding: 10px 15px;\n  border: 1px solid #444;\n  border-radius: 5px 0 0 5px;\n  background-color: #2d2d2d;\n  color: #f1f1f1;\n  font-size: 16px;\n}\n\n.search-button {\n  padding: 10px 20px;\n  background-color: #4a7bff;\n  color: white;\n  border: none;\n  border-radius: 0 5px 5px 0;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n\n.search-button:hover:not(:disabled) {\n  background-color: #3a67e8;\n}\n\n.search-button:disabled {\n  background-color: #6c7a9c;\n  cursor: not-allowed;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 20px 0;\n}\n\n.loading-spinner {\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top: 4px solid #f1f1f1;\n  width: 30px;\n  height: 30px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 10px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.search-error {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: #ff6b6b;\n  padding: 10px;\n  border-radius: 5px;\n  margin: 10px 0;\n}\n\n.search-results {\n  min-height: 500px;\n  max-height: 800px;\n  overflow-y: auto;\n  padding: 10px;\n  margin-top: 20px;\n}\n\n.search-results h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #444;\n  padding-bottom: 10px;\n  position: sticky;\n  top: 0;\n  background-color: #1e1e1e;\n  z-index: 10;\n}\n\n.results-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 25px;\n}\n\n.result-card {\n  background-color: #2d2d2d;\n  border-radius: 5px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 200px;\n}\n\n.result-card:hover {\n  transform: translateY(-5px);\n}\n\n.result-card h4 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  color: #f1f1f1;\n  font-size: 18px;\n}\n\n.book-summary {\n  margin-top: 10px;\n  font-size: 14px;\n  color: #ccc;\n  flex-grow: 1;\n  max-height: 100px;\n  overflow-y: auto;\n}\n\n.result-actions {\n  display: flex;\n  margin-top: 15px;\n  gap: 10px;\n}\n\n.read-button, .add-button, .disabled-button {\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  text-align: center;\n  text-decoration: none;\n  flex: 1;\n  transition: background-color 0.3s;\n}\n\n.read-button {\n  background-color: #4a7bff;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n.read-button:hover {\n  background-color: #3a67e8;\n}\n\n.add-button {\n  background-color: transparent;\n  color: #f1f1f1;\n  border: 1px solid #f1f1f1;\n  cursor: pointer;\n}\n\n.add-button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.disabled-button {\n  background-color: #555;\n  color: #aaa;\n  border: none;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
